module.exports = __webpack_public_path__ + "img/choose-4.7f849a3e.png";